import React, { useEffect, useState, useRef } from "react";
import { Row, Col, Card, Avatar, Rate, Tag, Typography } from "antd";
import {
  SettingOutlined,
  StarFilled,
  EnvironmentFilled,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import stars from "../../../assets/icons/Star23.png";
import "./Review.css";
import moment from "moment";
import noData from "../../../assets/img/Emptyjobs.png";
import { getImage } from "../../../utilities/storageOperations/downloadURL";
import Cards from "../../My Favorites/FavoriteCards/Cards";
import { set } from "lodash";
const Reviews = ({ Reviews }) => {
  const { Meta } = Card;
  const { Text } = Typography;
  const myRef = useRef(null);
  const [countryFlag, setCountryFlag] = React.useState();
  const [check, setCheck] = useState("hidden");
  const [checkSeeMore, setCheckSeeMore] = useState(true);
  const [checkSeeLess, setcheckSeeLess] = useState(false);
  const [checkBorder, setCheckBorder] = useState(true);
  const [profilePic, setProfilePic] = React.useState([]);
const [morethanThree,setMoreThanThree]=useState(false)
  // const [morethanThree,setMoreThanThree]=useState(fal)
  useEffect(() => {}, [Reviews]);
  const Pdetails = useSelector(
   (state) => state.getProfileDetailsReducer.details
 );

  const handle_checkSeeMore = () => {
    setCheck("auto");
    setCheckSeeMore(false);
    setcheckSeeLess(true);
    setCheckBorder(false);
  };
  const handle_checkSeeLess = () => {
    setCheck("hidden");
    setcheckSeeLess(false);
    setCheckSeeMore(true);
    setCheckBorder(true);

    myRef.current.scrollTop = 0;
  };

  // useEffect(async () => {
  //    if (Reviews?.users?.profile.PictureUrl) {
  //      if (Reviews?.users?.profile.PictureUrl) {
  //        profilePic = await getImage(Reviews?.users?.profile.PictureUrl);
  //      }
  //      setProfilePic(profilePic);
  //    }
  // }, [Reviews]);

  var countrycodedict = {
    "United States": "us",
    Texas: "TK",
    // ... fill in
  };
  const getCountryCode = async (countryName) => {
    // fetch("https://restcoun\tries.eu/rest/v2/name/United States").then(resp=>{
    //    return resp.json();
    // }).then(json=>{
    //    console.log(json[0].alpha2Code,'Country');
    // })
    // const flag = 'https://lipis.github.io/flag-icon-css/flags/4x3/' + countrycodedict['United States'] + '.svg';
    // const flag = 'https://flagcdn.com/36x27/'+countrycodedict['United States'] +'.png';
    const flag = (await "https://flagcdn.com/36x27/") + countryName + ".png";
    setCountryFlag(flag);
  };
  // const getDp = async (i) =>
  // {
  //    let profilePic = "";
  //    console.log('S3 Key ' , Reviews[i]?.users?.profile.PictureUrl);
  //    profilePic = await getImage(Reviews[i]?.users?.profile.PictureUrl)
  //    console.log("PP", profilePic);
  //    return profilePic;
  //  }
 
  return (
    <>
      {/* <Cards
              count={
               Reviews.length >= 2
                  ? Reviews.length
                  : Reviews.length
              }
              goto={"/reviews"}
            ></Cards> */}
      <div
        className="review-card-parent"
        style={{ overflow: check }}
        ref={myRef}
      >
        {Reviews?.length ? (
          Reviews?.map((items, i) => {
            if (i > 2 && checkSeeMore) {
              return;
            }
          
            {
              return (
                <div className="Review-card" style={{ marginTop: "10px" }} key={i}>
                  {i==0 &&<Row className="profile-dp-div">
                    <div className={"reviews"} style={{ marginLeft: "10px" }}>
                      Reviews
                    </div>
                    {/* <Rate value={2} className='profile-rating' />  */}
                    <div className="gig_star_cp">
                      <StarFilled style={{ padding: "4px" }} />
                    </div>
                    <div
                      style={{
                        color: "#7e7e7e",
                        fontSize: "12px",
                        paddingTop: "1px",
                        marginRight: '1px'
                      }}
                    >
                      {Pdetails?.user_Schema?.Profiles?.Rating}
                    </div>
                    <p
                      className="ratings-text"
                      style={{ padding: "1px 0 0 0 " }}
                    >
                      {items.assignment?.Rate}{" "}
                      <Text style={{ color: "#7e7e7e" }}>
                        ({Reviews.length})
                      </Text>
                    </p>
                   
                  </Row>}
                  <Meta
                    style={{ marginLeft: "10px" }}
                    avatar={
                      <div className="imgtext">
                        {items?.UserName ? items.UserName[0].split("")[0] : ""}
                      </div>
                      // <div className="rev-img-text">
                      //    {items?.users ? (
                      //       Reviews[i]?.users?.profile?.PictureUrl ? (
                      //          <img
                      //             className="profile-image"
                      //             alt="picture"
                      //             src={''}
                      //          />
                      //       ) : (
                      //          <div className="imgtext">
                      //             {items?.users ? items.users?.name.split("")[0]
                      //                : ""}
                      //          </div>
                      //       )
                      //    ) : null}
                      // </div>
                    }
                    // avatar={<div className="rev-img-text">
                    // {items.users?.name.split("")[0]}
                    // </div>}
                    title={
                      <div>
                        {items.UserName[0]}{" "}
                        <StarFilled
                          style={{
                            padding: "4px",
                            color: "#ffba08",
                            fontSize: "12px",
                          }}
                        />
                        <Text className="ratings-text">
                          {items.rating.ConsultantRating
                            ? (
                                (items.rating.ConsultantRating.Communication +
                                  items.rating.ConsultantRating
                                    .WorkingKnowledge +
                                  items.rating.ConsultantRating
                                    .Recommendation) /
                                3
                              ).toFixed(1)
                            : "N/A"}
                        </Text>
                      </div>
                    }
                    description={
                      <div className="country-name">
                        {/* <img src={countryFlag} /> */}
                        {/* <img style={{ width: '18px', marginRight: '5px' }} src="https://flagcdn.com/48x36/pk.png"></img> */}
                        {items?.Country.length != 0
                          ? items?.Country
                          : "Islamabad, Pakistan"}
                      </div>
                    }
                  />
                  <p className="Review-para" style={{ marginLeft: "10px" }}>
                    {items?.rating?.ConsultantComment}
                  </p>
                  <div className="span-time" style={{ marginLeft: "10px" }}>
                    {moment(items.rating?.Created).fromNow()}
                  </div>
                  {Reviews.length > 3 && i == 2 && checkSeeMore && (
                    <div
                      className="see-more-text"
                      onClick={handle_checkSeeMore}
                    >
                      See more{""} 
                    </div>
                  ) }
                  {i === Reviews.length - 1  && checkSeeLess && (
                    <div
                      className="see-more-text"
                      style={{marginRight:"5%"}}
                      onClick={handle_checkSeeLess}
                    >See less</div>
                  ) }
                  {i === Reviews.length - 1 ||
                  (i === 2 && checkBorder) ? null : (
                    <div className="bottom-line"></div>
                  )}
                </div>
              );
            }
          })
        ) : (
          <div
            className="Review-card"
            style={{ verticalAlign: "flex-start", background: "#fff" }}
          >
            <Row style={{ padding: "2%" }}>
              <div>Reviews </div>
              {/* <img src={stars} /> */}
              <StarFilled
                style={{ padding: "4px", color: "#ffba08", fontSize: "12px" }}
              />
              3.5 (0)
            </Row>
            <div
              style={{
                width: "50%",
                margin: "auto",
              }}
            >
              <img src={noData} style={{ width: "100%" }} />
            </div>
            <div style={{ textAlign: "center" }}>No Reviews!</div>
          </div>
        )}
      </div>
    </>
  );
};
export default Reviews;
